import { Component } from "react";
import { ESalesDetails } from "../../../services/insurance/common";
import { USER } from "../../../constants/insurance/constant";
import ESalesTable from './esalesqueue-data.js';
import Container from '@mui/material/Container';
import Alert from '@mui/material/Alert';
import { AppointmentDetails, checkSlaTime } from "../../../services/insurance/common";
import AlertTitle from '@mui/material/AlertTitle';
import { getAppointmentDate, getAppointmentTime } from "../../../services/insurance/common";
import moment from "moment";
class ESalesQueue extends Component {

  constructor(props) {
    super(props);
    let pgTrack = JSON.parse(localStorage.getItem("pageTracking"));
    this.state = {
      state: props?.location?.state,
      requests: props?.location?.state?.requests ?? [],
      rows: [],
      pageNo: -1,
      startDate: moment().subtract(1, "month").toISOString(),
      endDate: moment().toISOString(),
      messageAPI: "",
      searchAppointment: this.props.searchAppointment,
    };
    this.setIsMobileView = this.setIsMobileView.bind(this);
  }

  setIsMobileView(val) {
    this.setState({...this.state, isMobileView: val});
  }

  componentDidUpdate(prevProps) {
    // You don't have to do this check first, but it can help prevent an unneeded render
    if (this.props.searchAppointment !== prevProps.searchAppointment) {
      this.setState({
        searchAppointment: this.props.searchAppointment
      }, () => {
        this.callESalesDetails(this.props.searchAppointment, 1)
      });
    }
    if( this.props.selectedProviders.length !== prevProps.selectedProviders.length ){
      this.callESalesDetails(null, 1, this.state.startDate, this.state.endDate)
    }
  }


  showErrorMessage() {
    return (this.state.messageAPI !== '' ? <Alert severity="error">
      <AlertTitle className="uppercase">{this.state.messageAPI}</AlertTitle>
      <strong>Please Logout and try again !</strong>
    </Alert> : '')
  }

  getCreationDate(appointmentDate) {
    let date = appointmentDate.split('/')[1]
    date = date.split('(')[1];
    date = date.split('-')[0];
    date = new Date(parseInt(date));
    let year = date.getFullYear();
    let month = date.getMonth();
    let day = date.getDate();
    date = new Date(year, month, day);
    let dateObject = new Date(date);
    return dateObject.toDateString();
  }

  getAppointmentTime(appointmentDate) {
    let date = appointmentDate.split('/')[1]
    date = date.split('(')[1];
    date = date.split('-')[0];
    date = new Date(parseInt(date));
    let year = date.getFullYear();
    let month = date.getMonth();
    let day = date.getDate();

    date = new Date(year, month, day);
    let dateObject = new Date(date);

    return dateObject.toISOString();
  }

  createData(Id, eQuote, error, name, email, phoneNo, corporatename, city, state, createdOn, createdTime, allData) {
    return {
      Id,
      eQuote,
      error,
      name,
      email,
      phoneNo,
      corporatename,
      city,
      state,
      createdOn,
      createdTime,
      allData
    };
  }


  setRowsOfTable = (pageNo) => {
    let rows = [];
    const that = this;
    if (this.state.requests && this.state.requests !== '' && this.state.requests.length > 0) {
      let tuples = this.state.requests;
      if (tuples) {
        tuples.map((elem, index) => {
          if (elem !== undefined) {
            let requestJSON = elem.requestJSON;

            rows.push(this.createData(
              elem.id,
              elem.eQuote,
              elem.error,
              elem.name,
              elem.email,
              elem.phoneNo,
              elem.corporateName,
              elem.requestJSON.city,
              elem.requestJSON.state,
              getAppointmentDate(elem.dateTimeCreated),
              getAppointmentTime(elem.dateTimeCreated),
              elem
            ))
          }
          return true;
        })
      }
      else {
        return false;
      }

    }
    this.setState({
      rows: rows,
      pageNo: pageNo,
    })
  }

  onChangePageEsalesData = (value) => {
    if (value != null) {
      console.log("value", value);
      this.setState({
        rows: [],
        pageNo: value,
      }, () => {
        console.log("shgjdnbghcjdncgj", value);
        this.callESalesDetails(null, value, this.state.startDate, this.state.endDate)
      })
    }
  }
  onChangeStartDate = (value) => {
    this.setState({
      startDate: value
    })
    console.log("start date ::", value)
  }
  onChangeEndDate = (value) => {
    this.setState({
      endDate: value
    })
    console.log("end date :: ", value)
  }

  onDateSearch = (value) => {
    if (value) {
      this.setState({
        pageNo: 0
      }, () => {
        let pgTrack = JSON.parse(localStorage.getItem("pageTracking"))
        this.callESalesDetails(null, this.state.pageNo, pgTrack&&pgTrack.startTime?pgTrack.startTime:this.state.startDate, pgTrack&&pgTrack.endTime?pgTrack.endTime:this.state.endDate)
      })
    }
  }

  callESalesDetails(searchESales, pageNo, firstDate, endDate) {
    const that = this;
  
    AppointmentDetails(searchESales, pageNo - 1, firstDate, endDate, "RequestCreationDate").then(data => {
      if (data && data.errorStatus && data.errorStatus !== 200 && data.errorResponse && data.errorResponse !== undefined) {
        that.setState({
          messageAPI: data?.errorResponse ? data?.errorResponse?.data?.responseStatus?.message : ''
        })
      }
      else {
        that.setState((state)=>({
            requests: data && data.queueRequests && data.queueRequests.queueList ? data.queueRequests.queueList : [],
            messageAPI: '',
            totalRows: data &&data.queueRequests && data.queueRequests.totalQueueRequest ? data.queueRequests.totalQueueRequest:null,
            // totalRows: state && state.totalRows? state.totalRows:data.queueRequests.totalQueueRequest,
          }), () => {
            let pgDetail = JSON.parse(localStorage.getItem("pageTracking"));
            pgDetail.totalRows = data &&data.queueRequests && data.queueRequests.totalQueueRequest ? data.queueRequests.totalQueueRequest:null;
            // pgDetail.totalRows = this.state && this.state.totalRows? this.state.totalRows:data.totalRows;
            localStorage.setItem("pageTracking",JSON.stringify(pgDetail));
            that.setRowsOfTable(pageNo)
          });
        }
    })
  }

  componentDidMount() {
    if (!localStorage.getItem('access_token')) {
      this.props.history.push('./login')
    } else {
      USER.user = localStorage.getItem("user_details") ? JSON.parse(localStorage.getItem("user_details")) : null;
      
      if(this.state.state){
        this.setState({
          requests : this.props.location.state.requests,
          totalRows : this.props.location.state.totalRows,
          messageAPI: '',
        },() => {
          this.setRowsOfTable(1)
        })
      }else{
        console.log("componentDidMount::" + this.state.status + "Call Appointment")
        // let data = JSON.parse(localStorage.getItem("pageTracking"))
        this.callESalesDetails(null, 1, this.state.startDate, this.state.endDate);
      }
    }
  }

  render() {
    return (
      <Container maxWidth="xlg" className="pt-3">
        {this.showErrorMessage()}
        <ESalesTable 
          pageNo={this.state.pageNo} 
          totalRows={this.state.totalRows || 0} 
          rows={this.state.rows || []} 
          onChangePage={(event) => this.onChangePageEsalesData(event)}
          onChangeStartDate={(event) => this.onChangeStartDate(event)} 
          onChangeEndDate={(event) => this.onChangeEndDate(event)}
          searchAppointment = {this.state.searchAppointment}
          setIsMobileView = {this.setIsMobileView}
          onDateSearch={(event) => this.onDateSearch(event)}>
        </ESalesTable>
      </Container >
    );
  }

}

export default ESalesQueue;